<div class="d-flex flex-column px-4 pt-3 pb-4">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <h3 *ngIf="!edit" class="mb-0">Cotización offline</h3>

        <h3 *ngIf="edit" class="mb-0">Solicitud offline</h3>


    </div>
    <div>
        <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
          <span aria-hidden="true" style="font-size: 50px; font-weight: 100;">&times;</span>
        </button>
    </div>
  </div>

    <div *ngIf="!edit" class="d-flex mt-3 mb-4 justify-content-between mx-auto w-100" style="gap: .25em;">
    <button
              class="btn-tabs w-100 position-relative"
              style="border: 1px solid #ececec"
              [ngStyle]="{
                        'background-color': tab === 'hotel' ? buttonColorActive : '#fcfcfc',
                        'color': tab === 'hotel' ? buttonTextActive : buttonTextActive
                        }"
              (click)="tabActive('hotel')">
              HOTEL
              <span *ngIf="formHotelEdited"
                    class="position-absolute py-1 d-flex justify-content-between align-items-center px-2"
                    style="right: 0; bottom: -26px; width: 100%;"
                    [ngStyle]="{
                        'background-color': buttonColorActive,
                        'color': buttonTextActive
                      }"
              >
                <span>
                  <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;">
                    Carga de formulario
                  </p>
                </span>
                <span
                      style="border-radius: 2px;padding: 1px 4px; cursor: pointer"
                      class="d-flex flex-justify-center align-items-center"
                      [ngStyle]="{'border': '1px solid' + buttonTextActive }"
                      tooltip="Borrar formulario de hotel"
                      placement="bottom"
                      (click)="resetForm('hotel')">
                  <p class="mb-0"  style="font-family: 'Rubik', serif; font-size: 13px;">
                    X
                  </p>
                </span>
              </span>
            </button>
    <button
              class="btn-tabs w-100 position-relative"
              style="border: 1px solid #ececec"
              [ngStyle]="{
                        'background-color': tab === 'transfer' ? buttonColorActive : '#fcfcfc',
                        'color': tab === 'transfer' ? buttonTextActive : buttonTextActive
                        }"
              (click)="tabActive('transfer')">TRASLADO
               <span *ngIf="formTransferEdited"
                    class="position-absolute py-1 d-flex justify-content-between align-items-center px-2"
                    style="right: 0; bottom: -26px; width: 100%;"
                    [ngStyle]="{
                        'background-color': buttonColorActive,
                        'color': buttonTextActive
                      }"
              >
                <span>
                  <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;">
                    Carga de formulario
                  </p>
                </span>
                <span
                      style="border-radius: 2px;padding: 1px 4px; cursor: pointer"
                      class="d-flex flex-justify-center align-items-center"
                      [ngStyle]="{'border': '1px solid' + buttonTextActive }"
                      tooltip="Borrar formulario de hotel"
                      placement="bottom"
                      (click)="resetForm('transfer')">
                  <p class="mb-0"  style="font-family: 'Rubik', serif; font-size: 13px;">
                    X
                  </p>
                </span>
              </span>
    </button>
    <button
              class="btn-tabs w-100 position-relative"
              style="border: 1px solid #ececec"
              [ngStyle]="{
                        'background-color': tab === 'rent-a-car' ? buttonColorActive : '#fcfcfc',
                        'color': tab === 'rent-a-car' ? buttonTextActive : buttonTextActive
                        }"
              (click)="tabActive('rent-a-car')">RENT A CAR
              <span *ngIf="formRentACarEdited"
                    class="position-absolute py-1 d-flex justify-content-between align-items-center px-2"
                    style="right: 0; bottom: -26px; width: 100%;"
                    [ngStyle]="{
                        'background-color': buttonColorActive,
                        'color': buttonTextActive
                      }"
              >
                <span>
                  <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;">
                    Carga de formulario
                  </p>
                </span>
                <span
                      style="border-radius: 2px;padding: 1px 4px; cursor: pointer"
                      class="d-flex flex-justify-center align-items-center"
                      [ngStyle]="{'border': '1px solid' + buttonTextActive }"
                      tooltip="Borrar formulario de hotel"
                      placement="bottom"
                      (click)="resetForm('rent-a-car')">
                  <p class="mb-0"  style="font-family: 'Rubik', serif; font-size: 13px;">
                    X
                  </p>
                </span>
              </span>
      </button>
  </div>

  <div *ngIf="edit" class="d-flex flex-column my-3 ">
    <h3 class="mb-0" *ngIf="editData.category === 'hotels'" style="line-height: 1.2;font-family: 'Rubik', serif;">Hotel</h3>
    <h3 class="mb-0" *ngIf="editData.category === 'transfers'" style="line-height: 1.2;font-family: 'Rubik', serif;">Traslado</h3>
    <h3 class="mb-0" *ngIf="editData.category === 'rentacar'" style="line-height: 1.2;font-family: 'Rubik', serif;">Rent a car</h3>
    <p

          class="mb-0 " style="font-family: 'Rubik'; font-size: 14px;">
            <span>
              Estado:
            </span>
            <span
                  class="px-2 rounded-pill"
                  style="width: fit-content;"
                  [ngStyle]="{
                            'background-color': editData.status === null || editData.status === 0 ? 'black' : '#5dc795',
                            'color': editData.status === null || editData.status === 0 ? 'white' : 'black'
              }">
              {{editData.status === 0 || editData.status === null ? 'Solicitada' : 'Procesada'}}

            </span>
          </p>
    <p

          class="mb-0 " *ngIf="editData.category === 'transfers'" style="font-family: 'Rubik'; font-size: 14px;">
            <span>
              Traslado:
            </span>
            <span style="font-family: 'Rubik'; font-size: 14px; font-weight: 600;">
              {{editData.oneWay ? ' Solo ida' : ' Ida y vuelta'}}

            </span>
      </p>
  </div>

    <div [ngClass]="{'d-block': tab==='hotel', 'd-none': tab!='hotel' }">
      <form *ngIf=" tab==='hotel'"  [formGroup]="formHotel" class="d-flex flex-column">
        <!-- Sección Cliente y tipo de solicitud -->
        <div class="d-flex flex-column mb-4 mt-2">
          <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Cliente y tipo de solicitud</p>

          <div class="row">
            <div class="col-6">
              <div class="d-flex align-items-center mb-2" style="gap: 0.5em;">
                <input
                  type="text"
                  class="form-control"
                  id="fileName"
                  name="fileName"
                  placeholder="Nombre File"
                  maxlength="50"
                  autocomplete="off"
                  formControlName="fileName"
                />
                <span *ngIf="formHotel.get('fileName')?.value?.length === 50" class="text-danger ml-2" style="font-size: 12px; font-weight: 600;"> Máximo 50 caracteres </span>
              </div>
            </div>
            <div class="col-6">
              <div class="d-flex align-items-start mb-2" style="gap: 1em;">
                <div class="d-flex flex-column w-100">
                  <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 500;font-size: 14px;">Tipo de solicitud</p>
                  <div class="d-flex" style="gap: 1em;">
                    <label class="form-check-label d-flex align-items-center"
                          style="font-family: 'Rubik', serif; font-size: 14px; gap: 0.4em;">
                      <input type="radio"
                            value="quotation"
                            formControlName="requestType"
                            [disabled]="edit" />
                      Cotización
                    </label>
                    <label class="form-check-label d-flex align-items-center"
                          style="font-family: 'Rubik', serif; font-size: 14px; gap: 0.4em;">
                      <input type="radio"
                            value="reservation"
                            formControlName="requestType"
                            [disabled]="edit" />
                      Reserva
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Input Nombre File (opcional, replica patrón de itinerary-owner) -->

          <!-- Bloque Datos del cliente (form completo, sin card) -->
          <div class="d-flex flex-column mt-3" formGroupName="client">
            <!-- Título con lupita al lado para buscar cliente existente -->
            <div class="d-flex align-items-center mb-2" style="gap: 0.5em;">
              <p class="mb-0"
                 style="font-family: 'Rubik', serif; font-weight: 600; font-size: 18px;">
                Datos del cliente
              </p>
              <button
                *ngIf="!edit"
                type="button"
                class="btn btn-sm btn-search"
                style="
                  width: 28px;
                  height: 28px !important;
                  border-radius: 6px;
                  padding: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: #000000;
                "
                data-placement="bottom"
                tooltip="Buscar cliente existente"
                (click)="openClientListModal()"
              >
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 658.4 595.4"
                     style="width: 28px; height: 28px; fill: #FFFFFF;" xml:space="preserve">
                  <path d="M407.5,346.7c14.3-20,22.6-44.5,22.6-70.9c0-67.5-54.9-122.4-122.4-122.4s-122.4,54.9-122.4,122.4s54.9,122.4,122.4,122.4
                    c26,0,50.1-8.1,69.9-22l59.7,59.7c4.1,4.1,9.5,6.2,14.8,6.2s10.7-2,14.8-6.2c8.2-8.2,8.2-21.5,0-29.7L407.5,346.7z M227.4,275.8
                    c0-44.3,36.1-80.4,80.4-80.4s80.4,36.1,80.4,80.4s-36.1,80.4-80.4,80.4S227.4,320.2,227.4,275.8z"/>
                </svg>
              </button>
              <span *ngIf="selectedClient"
                    style="font-family: 'Rubik', serif; font-size: 13px; color: #666;">
                ({{ selectedClient.first_name }} {{ selectedClient.last_name }})
              </span>
            </div>

            <!-- Título + Nombre + Apellido -->
            <div class="d-flex mb-2" style="gap: 1em;">
              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientFirstName"
                       name="clientFirstName"
                       placeholder="Nombre"
                       [maxLength]="50"
                       [readonly]="edit"
                       (keydown)="blockInvalidKeys($event, 'name')"
                       formControlName="first_name" />
                <span *ngIf="formHotel.get('client.first_name')?.hasError('required') &&
                            formHotel.get('client.first_name')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
              </div>

              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientLastName"
                       name="clientLastName"
                       placeholder="Apellido"
                       [maxLength]="50"
                       [readonly]="edit"
                       (keydown)="blockInvalidKeys($event, 'name')"
                       formControlName="last_name" />
              </div>
            </div>

            <!-- Email -->
            <div class="d-flex mb-2" style="gap: 1em;">
              <div class="position-relative w-100">
                <input type="email"
                       class="form-control"
                       id="clientEmail"
                       name="clientEmail"
                       placeholder="E-mail"
                       [maxLength]="80"
                       [readonly]="edit"
                       formControlName="email" />
                <span *ngIf="formHotel.get('client.email')?.hasError('required') &&
                            formHotel.get('client.email')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
                <span *ngIf="formHotel.get('client.email')?.hasError('email') &&
                            formHotel.get('client.email')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Email inválido
                </span>
              </div>
            </div>

            <!-- Phone code + Phone -->
            <div class="d-flex mb-2" style="gap: 1em;">
              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientPhoneCode"
                       name="clientPhoneCode"
                       placeholder="País + Cód. telefónico"
                       [readonly]="edit"
                       [matAutocomplete]="autoCountry"
                       autocomplete="off"
                       [value]="phoneCodeSelected || ''"
                       (input)="phoneCodeSelected = $any($event.target).value" />
                <mat-autocomplete
                  #autoCountry="matAutocomplete"
                  [displayWith]="displayCountryFn"
                  (optionSelected)="onCountrySelected($event.option.value)">
                  <mat-option *ngFor="let country of countriesData" [value]="country">
                    {{ country.country_name }} (+{{ country.phone_code }})
                  </mat-option>
                </mat-autocomplete>
                <span *ngIf="formHotel.get('client.phone_code')?.hasError('required') &&
                            formHotel.get('client.phone_code')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
              </div>

              <div class="position-relative" style="width: 50%;">
                <input type="text"
                       class="form-control"
                       id="clientPhone"
                       name="clientPhone"
                       placeholder="N° Teléfono"
                       [maxLength]="20"
                       [readonly]="edit"
                       (keydown)="blockInvalidKeys($event, 'number')"
                       formControlName="phone" />
                <span *ngIf="formHotel.get('client.phone')?.hasError('required') &&
                            formHotel.get('client.phone')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Obligatorio
                </span>
                <span *ngIf="formHotel.get('client.phone')?.hasError('pattern') &&
                            formHotel.get('client.phone')?.touched"
                      class="position-absolute text-danger ml-2"
                      style="font-size: 11px; font-weight: 600; bottom: -18px;">
                  Mínimo 6 dígitos
                </span>
              </div>
            </div>
          </div>
          <!-- Fin Datos del cliente -->
        </div>
        <!-- Fin sección Cliente y tipo de solicitud -->

        <div class="d-flex flex-column mb-4 mt-2" >
          <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Destino y fecha</p>
          <div class="d-flex align-items-center mb-2" style="gap: 1em;">
            <div class="position-relative" style="width: 70%">
              <input type="text"
                id="destination"
                name="destination"
                class="form-control"
                placeholder="Destino"
                [maxLength]="80"
                [minLength]="3"
                formControlName="destination"
                [matAutocomplete]="autoDestination"
                autocomplete="off">
              <mat-autocomplete
                #autoDestination="matAutocomplete"
                [displayWith]="displayDestinationFn"
                (optionSelected)="onDestinationSelected($event.option.value)">
                <ng-container *ngFor="let item of destinationOptions">
                  <ng-container *ngIf="item.type === 'city' && item.cities && item.cities.length > 0">
                    <mat-option disabled style="background-color: #f4f4f4; height: 42px">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center" style="gap: 0.25em">
                          <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                          <span class="mt-1"
                            style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important">Ubicación</span>
                        </div>
                        <div>
                          <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important">
                            {{ item.cities.length }} resultados
                          </span>
                        </div>
                      </div>
                    </mat-option>
                    <mat-option *ngFor="let city of item.cities" [value]="city">
                      <div class="d-flex align-items-center" style="gap: .75em; margin-left: 9px">
                        <img src="{{city?.country_logo}}" style="width: 16px; height: 16px; border-radius: 50%;" />
                        <p class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1">
                          {{ capitalize(city.city_name) }},
                          <span class="mb-0"
                            style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important">
                            {{ capitalize(city.city_province) }}{{ city.city_province ? "," : "" }}
                            {{ capitalize(city.country_name) }}
                          </span>
                        </p>
                      </div>
                    </mat-option>
                  </ng-container>
                </ng-container>
              </mat-autocomplete>
              <span *ngIf="formHotel.get('destination').hasError('required')"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
                Obligatorio
              </span>
              <span *ngIf="formHotel.get('destination').hasError('minlength') &&
                          formHotel.get('destination').touched"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
                Mínimo 3 caracteres
              </span>
              <span *ngIf="formHotel.get('destination').value?.length === 80"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
                Máximo 80 caracteres
              </span>
            </div>
            <div style="width: 30%; position:relative">
              <input type="text"
                #reservation_date
                readonly
                id="arrivalDepartureDate"
                name="arrivalDepartureDate"
                formControlName="arrivalDepartureDate"
                autocomplete="off"
                class="form-control input-ngxDateRangePicker"
                ngxDaterangepickerMd
                placeholder="Check-in - check-out"
                [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}"
                startKey="start"
                endKey="end"
                [autoApply]="true"
                [closeOnAutoApply]="true"
                [minDate]="minDate"
                [maxDate]="maxDate"
                (startDateChanged)="startDateClicked($event)"
                (endDateChanged)="endDateClicked($event)"
                [isInvalidDate]="isInvalidDate"
                (click)="fixCalendarPosition()"
                name="daterange"
                style="background-color: white;"
                [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': clientSetting?.clients_setting_global?.color_main_1},
                            ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': clientSetting?.clients_setting_global?.color_main_1}}"
                />
                <span *ngIf="
                            dateRange?.start === null && dateRange?.end === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
              >
                Obligatorio</span>
            </div>
          </div>
        </div>
        <!-- Input Nombre de hoteles + botón "¿No encuentra?" a la derecha -->
        <div class="row mb-4" style="gap: 0; position: relative;">
          <div class="col-8 position-relative" style="padding-right: 0.5em;">
            <input
              type="text"
              id="hotelsName"
              name="hotelsName"
              matInput
              class="form-control"
              placeholder="Nombre de hoteles"
              [maxLength]="100"
              formControlName="hotelsName"
              [matAutocomplete]="autoHotelsName"
              #hotelsNameTrigger="matAutocompleteTrigger"
              autocomplete="off"
              (focus)="onHotelsNameFocus()"
              (input)="onHotelsNameFocus()"
            />
            <mat-autocomplete
              #autoHotelsName="matAutocomplete"
              [displayWith]="displayHotelsNameFn"
              (optionSelected)="onHotelsNameSelected($event.option.value)"
            >
              <ng-container *ngFor="let item of hotelsNameOptions">
                <ng-container *ngIf="item.type === 'hotel' && item.hotels && item.hotels.length > 0">
                  <mat-option disabled style="background-color: #f4f4f4; height: 42px">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center" style="gap: 0.25em">
                        <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px" />
                        <span class="mt-1"
                          style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important">Hotel</span>
                      </div>
                      <div>
                        <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important">
                          {{ item.hotels.length }} resultados
                        </span>
                      </div>
                    </div>
                  </mat-option>
                  <mat-option *ngFor="let hotel of item.hotels" [value]="hotel">
                    <div class="d-flex align-items-center" style="gap: .75em; margin-left: 9px">
                      <img src="{{hotel?.country_logo}}" style="width: 16px; height: 16px; border-radius: 50%;" />
                      <p class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1">
                        {{ capitalize(hotel.name) }},
                        <span class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important">
                          {{ capitalize(hotel.city_name) }}{{ hotel.city_name ? "," : "" }}
                          {{ capitalize(hotel.city_province) }}{{ hotel.city_province ? "," : "" }}
                          {{ capitalize(hotel.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </mat-autocomplete>
            <span *ngIf="formHotel.get('hotelsName').hasError('required') &&
                        formHotel.get('hotelsName').touched"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
              Obligatorio
            </span>
            <span *ngIf="formHotel.get('hotelsName').value?.length === 100"
                  class="position-absolute text-danger ml-2"
                  style="font-size: 12px; font-weight: 600; bottom: -20px;">
              Máximo 100 caracteres
            </span>


            <!-- Dropdown extendido de sugerencias (position absolute, overlay sobre el contenido) -->
            <div *ngIf="showHotelSuggest"
                class="d-flex flex-column position-absolute"
                style="left: 0; right: 0; z-index: 1000; margin-top: 4px; padding: 0px 15px;">

              <span *ngIf="hotelSuggestError"
                    class="text-danger mb-2"
                    style="font-size: 12px; font-weight: 600;">
                {{ hotelSuggestError }}
              </span>

              <div *ngIf="hotelSuggestPending"
                  class="d-flex align-items-center mb-2"
                  style="gap: 0.5em; font-family: 'Rubik', serif; font-size: 13px;">
                <span class="text-warning" style="font-weight: 600;">
                  El hotel se está procesando. Intentá de nuevo en unos segundos.
                </span>
                <button type="button"
                        class="btn btn-sm"
                        style="background-color: #fcfcfc; border: 1px solid #ececec; padding: 0.3em 0.7em;
                              font-family: 'Rubik', serif; font-size: 12px;"
                        (click)="selectHotelSuggestion(hotelSuggestResults[0])">
                  Reintentar
                </button>
              </div>

              <!-- Dropdown custom con el mismo estilo que el mat-autocomplete de searchLocations -->
              <div *ngIf="hotelSuggestResults.length > 0"
                  class="d-flex flex-column"
                  style="background-color: white; border: 1px solid #ececec; border-radius: 4px;
                          box-shadow: 0 2px 4px rgba(0,0,0,0.08); max-height: 280px; overflow-y: auto;">

                <!-- Header igual al mat-option disabled de searchLocations -->
                <div class="d-flex justify-content-between align-items-center px-2"
                    style="background-color: #f4f4f4; height: 42px;">
                  <div class="d-flex align-items-center" style="gap: 0.25em;">
                    <img src="../../../../assets/icons/search-box/hotel_gris.svg"
                        style="width: 35px; height: 35px;" />
                    <span class="mt-1"
                          style="font-family: 'Rubik', serif; font-size: 13px !important;
                                font-weight: 600 !important;">
                      Sugerencias
                    </span>
                  </div>
                  <span style="font-family: 'Rubik', serif; font-size: 11px !important;
                              font-weight: 400 !important;">
                    {{ hotelSuggestResults.length }} resultados
                  </span>
                </div>

                <!-- Items con el mismo estilo visual que las mat-option de searchLocations -->
                <button *ngFor="let h of hotelSuggestResults"
                        type="button"
                        class="d-flex align-items-start mb-0 px-2 py-2"
                        style="background-color: white; border: none; border-bottom: 1px solid #f4f4f4;
                              text-align: left; cursor: pointer; font-family: 'Rubik', serif;
                              width: 100%;"
                        (mouseenter)="h._hover = true"
                        (mouseleave)="h._hover = false"
                        [style.background-color]="h._hover ? '#f9f9f9' : 'white'"
                        (click)="selectHotelSuggestion(h)">
                  <div class="d-flex align-items-start" style="gap: .75em; margin-left: 9px; width: 100%;">
                    <img *ngIf="h.image_urls && h.image_urls.length > 0"
                        [src]="h.image_urls[0]"
                        style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover; margin-top: 2px;" />
                    <div class="d-flex flex-column" style="flex: 1; min-width: 0;">
                      <p class="mb-0"
                        style="font-family: 'Rubik'; font-size: 14px !important;
                                font-weight: 600 !important; line-height: 1.2;
                                color: #333;">
                        {{ h.name || h.hotel_name || h.title || 'Hotel sin nombre' }}
                      </p>
                      <span *ngIf="h.description"
                            class="mb-0"
                            style="font-family: 'Rubik'; font-size: 12px !important;
                                  line-height: 1.2; font-weight: 400 !important;
                                  color: #666; margin-top: 2px;">
                        {{ h.description }}
                      </span>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>

          <div class="col-4 d-flex align-items-end" style="padding-left: 0.5em;">
            <button
              *ngIf="!edit && !showHotelSuggest"
              type="button"
              class="btn btn-link p-0"
              style="font-family: 'Rubik', serif; font-size: 13px; font-weight: 500;
                      color: #000000; text-decoration: none; text-align: left;
                      display: flex; align-items: flex-end; gap: 0.4em;
                      width: 100%; height: 38px; padding: 0;"
              tooltip="Buscar hotel en la base extendida"
              (click)="toggleHotelSuggest()"
            >
              ¿No encuentra el hotel? Buscar otra sugerencia
            </button>

            <div *ngIf="showHotelSuggest"
                 class="d-flex align-items-center w-100"
                 style="height: 38px; gap: 0.4em;">
              <span *ngIf="hotelSuggestLoading"
                    class="d-flex align-items-center flex-grow-1"
                    style="gap: 0.4em; font-family: 'Rubik', serif; font-size: 12px; color: #666;">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Buscando...
              </span>
              <span *ngIf="hotelSuggestEnriching"
                    class="d-flex align-items-center flex-grow-1"
                    style="gap: 0.4em; font-family: 'Rubik', serif; font-size: 12px; color: #666;">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Procesando...
              </span>
              <button *ngIf="!hotelSuggestLoading && !hotelSuggestEnriching"
                      type="button"
                      (click)="closeHotelSuggest()"
                      aria-label="Cerrar"
                      style="border: 1px solid #ececec; background-color: #fcfcfc; cursor: pointer;
                             font-size: 16px; color: #999; width: 38px; height: 38px;
                             border-radius: 6px; line-height: 1; padding: 0;">
                ×
              </button>
            </div>
          </div>
        </div>

         <div class="d-flex">
            <div class="position-relative w-100">
               <input type="text" class="form-control" id="zone" name="zone" placeholder="Zonas de interés" [maxLength]="100" formControlName="zone">
                <span *ngIf="formHotel.get('zone').value?.length === 100"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 100 caracteres
                </span>
            </div>
        </div>
        <div class="d-flex mt-4" style="gap: 1em;">
          <div class="d-flex flex-column p-3" style="width: 33%; background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;">
              <p class="mb-2" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Régimen</p>
                <div *ngFor="let val of boardType; let i = index" >
                  <label class="mb-1 pb-1 w-100 form-check-label d-flex justify-content-between pr- align-items-center"
                         [ngStyle]="{'border-bottom': i !== (boardType.length - 1) ? '1px solid #ececec' : ''}">

                       <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;"><span style="font-weight: 500;">{{val.description}}</span> - {{val.label}}</span>
                       <input
                         type="checkbox"
                         [value]="val.value"
                         [disabled]="edit"
                         (change)="onChangeSelectForm($event,'hotel', 'meals')"
                          [checked]="formHotel.get('meals').value.includes(val.value)"
                         class="me-2"
                         style="cursor: pointer"
                       />
                 </label>
                </div>
            </div>
            <div class="d-flex flex-column p-3" style="width: 33%;  background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;">
              <p class="mb-2" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Categoría habitación</p>
               <!-- <input type="text" formControlName="meals"> -->
                <div *ngFor="let val of roomType; let i = index">
                  <label class="mb-1 pb-1 w-100 form-check-label d-flex justify-content-between pr- align-items-center"
                              [ngStyle]="{'border-bottom': i !== (roomType.length - 1) ? '1px solid #ececec' : ''}">
                  <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                  <input
                    type="checkbox"
                    [value]="val.value"
                    [disabled]="edit"
                    (change)="onChangeSelectForm($event,'hotel', 'category')"
                      [checked]="formHotel.get('category').value.includes(val.value)"
                    class="me-2"
                    style="cursor: pointer"
                  />
                 </label>

                </div>
            </div>
            <div class="d-flex flex-column p-3" style="width: 33%;  background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;">
              <p class="mb-2" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Tipo cama</p>
               <!-- <input type="text" formControlName="meals"> -->
                <div *ngFor="let val of bedType; let i = index">
                  <label class="mb-1 pb-1 w-100 form-check-label d-flex justify-content-between pr- align-items-center"
                               [ngStyle]="{'border-bottom': i !== (bedType.length - 1) ? '1px solid #ececec' : ''}">
                  <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                  <input
                    type="checkbox"
                    [value]="val.value"
                    [disabled]="edit"
                    (change)="onChangeSelectForm($event,'hotel', 'type_bed')"
                      [checked]="formHotel.get('type_bed').value.includes(val.value)"
                    class="me-2"
                    style="cursor: pointer"
                  />
                 </label>
                </div>
            </div>
        </div>
        <div class="d-flex mt-3 mb-3" style="gap: 1em; ">
          <div class="d-flex flex-column" style="width: 100%;">
              <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Habitaciones</p>

              <div class="d-flex mb-3" style="gap: 1em;">
                <div class="position-relative w-100" >
                  <input type="number" class="form-control" id="qty_rooms" name="qty_rooms" placeholder="N° habitaciones" min="0" (keydown)="blockInvalidKeys($event, 'number')" (keypress)="limitNumber($event, 99)" max="99" formControlName="qty_rooms">
                  <span *ngIf="formHotel.get('qty_rooms')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
                </div >
                <div class="position-relative w-100" >
                  <input type="number" min="1" class="form-control" id="price_night" name="price_night" placeholder="Presupuesto" (keypress)="limitNumber($event, 9999999)" max="9999999"  (keydown)="blockInvalidKeys($event, 'number')" formControlName="price_night">
                  <span *ngIf="
                              formHotel.get('price_night').value && formHotel.get('price_night')?.value < 9999999"
                        class="position-absolute ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;color: #cbcbcb "
                    >Número sin "," ni "."
                   </span>
                   <span *ngIf="formHotel.get('price_night')?.value === 9999999"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 9999999
                </span>
                </div>
                <div class="position-relative w-100">
                  <input type="text" id="currency" name="currency" class="form-control" placeholder="Moneda" [maxLength]="13" (input)="formatCurrencyInput($event)" (keydown)="blockInvalidKeys($event, 'currency')" formControlName="currency">
                   <span *ngIf="
                              formHotel.get('currency')?.value && formHotel.get('currency')?.value.length > 0 && formHotel.get('currency')?.value.length < 13"
                        class="position-absolute ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;color: #cbcbcb "
                    >Ej: USD, ARS, EUR
                   </span>
                   <span *ngIf="formHotel.get('currency')?.value && formHotel.get('currency')?.value.length === 13"
                        class="position-absolute ml-2 text-danger"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;"
                    >Máximo 3 monedas
                   </span>
                </div>
              </div>
          </div>
          <div class="d-flex flex-column " style="width: 100%;">
            <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Huéspedes</p>
             <div class="d-flex mb-1" style="gap: 1em;">
               <div class="d-flex w-100" style="gap: 1em;">
                <div class="w-100 position-relative">
                  <input type="number" class="form-control" min="2" id="adults" name="adults" (keypress)="limitNumber($event, 99)" max="99" placeholder="Adultos" (keydown)="blockInvalidKeys($event, 'number')" formControlName="adults">
                   <span *ngIf="
                              formHotel.get('adults').value === null"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                   <span   *ngIf="formHotel.get('adults')?.hasError('min')"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Mínimo 2
                   </span>
                   <span *ngIf="formHotel.get('adults')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
                </div>
                 <div class="w-100 position-relative">
                  <input type="number" min="0" class="form-control" id="childs" name="childs" (keypress)="limitNumber($event, 99)" max="99" (keydown)="blockInvalidKeys($event, 'number')" placeholder="Niños" formControlName="childs">
                  <span *ngIf="
                              formHotel.get('childs').value === null"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                  <span *ngIf="formHotel.get('childs')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
                </div>
               </div>
               <div class="w-100 position-relative">
                 <input type="text" class="form-control" id="age_childs" name="age_childs" placeholder="Edades de los niños. Ej: 1, 4, 7" (keydown)="blockInvalidKeys($event, 'age_childs')" formControlName="age_childs">
                 <span *ngIf="
                              !formHotel.get('age_childs').valid && formHotel.get('childs').value > 0"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                 <span *ngIf="
                              formHotel.get('age_childs').value"
                        class="position-absolute ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;color: #cbcbcb "
                    >Ej: 1, 4, 7
                   </span>
               </div>
             </div>
          </div>
        </div>
         <div class="d-flex">
          <div class="w-100 position-relative">
            <input type="text" class="form-control" id="nationality" id="nationality" placeholder="Nacionalidad" [maxLength]="50" (keydown)="blockInvalidKeys($event, 'name')" formControlName="nationality">
            <span *ngIf="formHotel.get('nationality').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>
          </div>
          <div>
            <!-- <input type="text" formControlName="currency"> -->
          </div>
        </div>

          <div class="d-flex mt-3 flex-column">
          <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Comentario</p>
          <div class="d-flex flex-column">
            <div class="w-100 position-relative">
              <textarea name="comment_contact" id="comment_contact" class="form-control" placeholder="Pregunta o comentario" [maxLength]="500" style="min-height: 150px;" formControlName="comment_contact" rows="5" id=""></textarea>
               <span *ngIf="formHotel.get('comment_contact').value?.length === 500"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 500 caracteres
                </span>
            </div>
          </div>
         </div>

          <!-- Sección Competencia -->
          <div class="d-flex mt-3 flex-column">

            <!-- Estado colapsado: solo el botón "Generar competencia" -->
            <div class="d-flex align-items-center justify-content-end" *ngIf="!competitorSectionOpen && competitorUrlsArray.length === 0">
              <div class="d-flex flex-column align-items-end" style="gap: 0.25em;">
                <button *ngIf="!edit"
                        type="button"
                        class="btn"
                        style="background-color: #fcfcfc; border: 1px solid #ececec; padding: 0.5em 1em; font-family: 'Rubik', serif; font-size: 14px; font-weight: 500;"
                        [disabled]="!canEditCompetitor"
                        [tooltip]="!canEditCompetitor ? 'Completá los campos obligatorios del formulario para habilitar competencia' : null"
                        (click)="openCompetitorSection()">
                  + Generar competencia
                </button>
                <span *ngIf="!edit && !canEditCompetitor"
                      style="font-family: 'Rubik', serif; font-size: 11px; color: #999;">
                  Completá los campos obligatorios para habilitar competencia
                </span>
                <p *ngIf="edit"
                   class="mb-0"
                   style="font-family: 'Rubik', serif; font-size: 13px; color: #999;">
                  Sin datos de competencia.
                </p>
              </div>
            </div>

            <!-- Estado expandido: URLs + imágenes -->
            <div *ngIf="competitorSectionOpen || competitorUrlsArray.length > 0"
                 class="d-flex flex-column">
              <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Competencia</p>

              <!-- Header del desplegable con botón para colapsar -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span style="font-family: 'Rubik', serif; font-size: 13px; color: #666;">
                  URLs de la competencia
                </span>
                <button *ngIf="!edit"
                        type="button"
                        class="btn"
                        style="border: none; background: transparent; font-size: 18px; color: #999; padding: 0;"
                        [disabled]="!canEditCompetitor"
                        (click)="closeCompetitorSection()"
                        aria-label="Cerrar sección competencia">
                  ×
                </button>
              </div>

              <!-- Lista de URLs (cada una con su input + botón X + botón + al final) -->
              <div formArrayName="competitorUrls">
                <div *ngFor="let urlCtrl of competitorUrlsArray.controls; let i = index"
                     class="d-flex align-items-center mb-2 position-relative"
                     style="gap: 0.5em;">
                  <input
                    type="text"
                    class="form-control"
                    [id]="'competitorUrl_' + i"
                    [name]="'competitorUrl_' + i"
                    placeholder="URL de la competencia"
                    [maxLength]="500"
                    [formControlName]="i"
                    [readonly]="edit || !canEditCompetitor"
                  />
                  <button *ngIf="!edit"
                          type="button"
                          (click)="addCompetitorUrl()"
                          [disabled]="!canEditCompetitor"
                          aria-label="Agregar URL"
                          style="border: 1px solid #ececec; background-color: #fcfcfc;
                                 border-radius: 6px; width: 38px; height: 38px;
                                 font-size: 20px; cursor: pointer; padding: 0; line-height: 1;">
                    +
                  </button>
                  <button *ngIf="!edit && competitorUrlsArray.length > 1"
                          type="button"
                          (click)="removeCompetitorUrl(i)"
                          [disabled]="!canEditCompetitor"
                          aria-label="Quitar URL"
                          style="border: 1px solid #ececec; background-color: #fcfcfc;
                                 border-radius: 6px; width: 38px; height: 38px;
                                 font-size: 18px; cursor: pointer; padding: 0; line-height: 1; color: #999;">
                    −
                  </button>
                  <span *ngIf="urlCtrl.hasError('pattern') && urlCtrl.touched"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 11px; font-weight: 600; bottom: -18px; left: 0;">
                    URL inválida (debe comenzar con http:// o https://)
                  </span>
                </div>
              </div>

              <!-- Prints (colección global de imágenes) -->
              <div class="d-flex flex-column mt-3 mb-2">
                <p class="mb-1" style="font-family: 'Rubik', serif; font-weight: 500; font-size: 14px;">Prints</p>
                <span *ngIf="!edit" class="mb-2"
                      style="font-family: 'Rubik', serif; font-size: 12px; font-weight: 400; color: #cbcbcb;">
                  Máx. 5 MB por imagen. Formatos: JPG, PNG, WEBP.
                </span>

                <input
                  *ngIf="!edit"
                  type="file"
                  accept="image/*"
                  multiple
                  class="form-control mb-2"
                  id="competitorImages"
                  name="competitorImages"
                  [disabled]="!canEditCompetitor"
                  (change)="onCompetitorImagesSelected($event)"
                />

                <div *ngIf="competitorImagesArray.length > 0"
                     class="d-flex flex-row flex-wrap"
                     style="gap: 0.5em;">
                  <div *ngFor="let img of competitorImagesArray.controls; let i = index"
                       class="position-relative"
                       style="width: 96px; height: 96px;">
                    <img [src]="'data:image/jpeg;base64,' + img.value"
                         style="width: 96px; height: 96px; object-fit: cover; border-radius: 6px; border: 1px solid #ececec;" />
                    <button *ngIf="!edit"
                            type="button"
                            (click)="removeCompetitorImage(i)"
                            aria-label="Quitar imagen"
                            style="position: absolute; top: 2px; right: 2px; width: 22px; height: 22px;
                                   border-radius: 50%; border: none; background-color: rgba(0,0,0,0.6);
                                   color: white; font-size: 12px; line-height: 1; cursor: pointer; padding: 0;">
                      ×
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Fin sección Competencia -->
          <div *ngIf="!edit"  class="d-flex pt-4 justify-content-end align-items-center" style="height: 75px; gap: 1em;">

          <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 13px;font-weight: 500; width: 205px;">Puede completar todos los formularios en una sola solicitud</p>
          <!-- <button type="button" class="btn btn-continue" (click)="close()" [disabled]="disableButton">Close</button> -->
          <button type="button" class="btn btn-continue"  (click)="onSubmit()">Enviar</button>
        </div>
      </form>
    </div>
    <div [ngClass]="{'d-block': tab==='transfer', 'd-none': tab!='transfer' }">
      <form *ngIf=" tab==='transfer'" [formGroup]="formTransfer">


        <div class="d-flex flex-column mt-3 mb-3 position-relative">
          <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Destino y fechas</p>
          <div class="d-flex position-relative mb-3" style="gap: 1em;">
                    <div class="position-relative" style="width: 100%">
                      <div class="d-flex flex-column" style="width: 100%">
                        <label *ngIf="edit" for="firstOrigin" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Origen</label>
                        <input type="text" id="firstOrigin" name="firstOrigin" [maxLength]="50" formControlName="firstOrigin" placeholder="Origen" class="form-control">

                           <span  *ngIf="formTransfer.get('firstOrigin').hasError('required')"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                            Obligatorio</span>
                    <span *ngIf="formTransfer.get('firstOrigin').hasError('minlength') &&
                            formTransfer.get('firstOrigin').touched"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Mínimo 3 caracteres
                </span>
                <span *ngIf="formTransfer.get('firstOrigin').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>


                      </div>

                    </div>

            <div class="position-relative" style="width: 100%">
                    <div class="d-flex flex-column " style="width: 100%">
                      <label *ngIf="edit" for="firstOrigin" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Destino</label>
                      <input type="text" id="firstDestination" name="firstDestination" [maxLength]="50" placeholder="Destino" formControlName="firstDestination" class="form-control">
                    </div>
                <span  *ngIf="formTransfer.get('firstDestination').hasError('required')"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                  Obligatorio</span>
                <span *ngIf="formTransfer.get('firstDestination').hasError('minlength') &&
                            formTransfer.get('firstDestination').touched"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Mínimo 3 caracteres
                </span>
                <span *ngIf="formTransfer.get('firstDestination').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>
            </div>
          </div>
        </div>

        <div class="d-flex  mb-4">
          <div class="d-flex w-100" style="gap: 1em;">
            <div class="w-100 d-flex flex-column position-relative">
              <label *ngIf="edit" for="firstArrivalDate" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Fecha ida</label>
              <input
              formControlName="firstArrivalDate"
              type="text"
              class="form-control input-search-box"
              style="background-color: white;"
              id="departureDate"
              placeholder="Fecha de recogida"
              autocomplete="off"
              bsDatepicker
              [minDate]="now"
              [bsConfig]="dpConfig"
              readonly
              [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': clientSetting?.clients_setting_global?.color_main_1},
                          ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': clientSetting?.clients_setting_global?.color_main_1}}"
            />
                  <span  *ngIf="formTransfer.get('firstArrivalDate').value === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                        Obligatorio</span>
            </div>
            <div class="w-100 position-relative d-flex flex-column">
               <label *ngIf="edit" for="firstTime" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Hora ida</label>
               <input
                  class="form-control input-search-box"
                  formControlName="firstTime"
                  type="time">
                  <span  *ngIf="formTransfer.get('firstArrivalDate').value === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                        Obligatorio</span>
            </div>

            <!-- <div class="d-flex w-100">
                <input type="text" class="form-control" placeholder="Número vuelo ida" formControlName="flyNumberIn">
            </div> -->
          </div>
        </div>

         <div class="d-flex mb-4">
          <div *ngIf="!edit" class="d-flex mb-3 w-100" style="gap: 1em;">
              <div class="w-100 d-flex flex-column">
                <input
                  formControlName="secondArrivalDate"
                  type="text"
                  class="form-control input-search-box"
                  style="background-color: white;"
                  id="departureDate"
                  placeholder="Fecha de vuelta"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="formTransfer.get('firstArrivalDate')?.value ? formTransfer.get('firstArrivalDate')?.value  : now"
                  [bsConfig]="dpConfig"
                  [disabled]="!formTransfer.get('firstArrivalDate')?.value"
                  (bsValueChange)="onDateChange($event)"
                />
              </div>
              <div class="w-100">
                          <input
                  class="form-control input-search-box"
                  formControlName="secondTime"
                  type="time">
              </div>
            </div>
            <div *ngIf="edit && formTransfer.get('secondArrivalDate').value !== null" class="d-flex mb-3 w-100" style="gap: 1em;">
              <div class="w-100 d-flex flex-column">
                <label *ngIf="edit" for="secondArrivalDate" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Fecha vuelta</label>
                <input
                  formControlName="secondArrivalDate"
                  type="text"
                  class="form-control input-search-box"
                  style="background-color: white;"
                  id="departureDate"
                  placeholder="Fecha de vuelta"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="formTransfer.get('firstArrivalDate').value"
                  [bsConfig]="dpConfig"
                  (bsValueChange)="onDateChange($event)"
                />
              </div>
              <div class="w-100 d-flex flex-column">
                <label *ngIf="edit" for="secondTime" style="font-family: 'Rubik', serif;font-size: 14px;font-weight: 600;">Fecha vuelta</label>
                          <input
                  class="form-control input-search-box"
                  formControlName="secondTime"
                  type="time">
              </div>
            </div>
            <!-- <div class="w-100">
                <input type="text" class="form-control" placeholder="Número vuelo vuelta" formControlName="flyNumberOut">
            </div> -->

        </div>

        <div class="d-flex flex-column mt-3 mb-3">
          <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Pasajeros</p>
          <div class="d-flex mb-4" style="gap: 1em;">
            <div class="w-100 position-relative">
              <input type="text" id="qty_bags" name="qty_bags" min="0" max="99" (keypress)="limitNumber($event, 99)" (keydown)="blockInvalidKeys($event, 'number')" class="form-control" placeholder="Cantidad Maletas" formControlName="qty_bags">
              <span   *ngIf="formTransfer.get('qty_bags')?.value === 99"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Máximo 99
              </span>
            </div>
            <div class="w-100 position-relative">
              <input type="number" id="adults" name="adults" min="0" max="99" class="form-control" (keypress)="limitNumber($event, 99)" (keydown)="blockInvalidKeys($event, 'number')" placeholder="Cantidad adultos" formControlName="adults">
                <span  *ngIf="formTransfer.get('adults').hasError('required')"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                        Obligatorio</span>
                <span   *ngIf="formTransfer.get('adults')?.hasError('min')"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Mínimo 1
                   </span>
                    <span   *ngIf="formTransfer.get('adults')?.value === 99"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Máximo 99
                   </span>
            </div>
          </div>
          <div class="d-flex mb-3" style="gap: 1em;">
            <div class="w-100 position-relative">
              <input type="number" min="0" max="99" class="form-control" (keypress)="limitNumber($event, 99)" (keydown)="blockInvalidKeys($event, 'number')" placeholder="Cantidad niños" formControlName="childs">
               <span  *ngIf="formTransfer.get('childs').value === null || formTransfer.get('childs').value === ''"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
                      >
                        Obligatorio</span>
                <span *ngIf="formTransfer.get('childs')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
            </div>
            <div class="w-100 position-relative">
              <input type="text" class="form-control" id="age_childs" name="age_childs" placeholder="Edades de los niños. Ej: 1, 4, 7" (keydown)="blockInvalidKeys($event, 'age_childs')" formControlName="age_childs">
              <span *ngIf="
                              !formTransfer.get('age_childs').valid && formHotel.get('childs').value > 0"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                    <span *ngIf="
                              formTransfer.get('age_childs').value"
                        class="position-absolute ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;color: #cbcbcb "
                    >Ej: 1, 4, 7
                   </span>
            </div>
          </div>
        </div>

        <div class="d-flex" style="gap: 1em;">
           <div class="d-flex flex-column p-3" style="width: 25%; background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;">
              <p class="mb-2" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Tipo traslado</p>

              <div *ngFor="let val of typeTransfer; let i = index">

                <label  class=" mb-1 pb-1 w-100 form-check-label d-flex justify-content-between align-items-center"
                 [ngStyle]="{'border-bottom': i !== (typeTransfer.length - 1) ? '1px solid #ececec' : ''}">
                  <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                   <input
                     type="checkbox"
                     [value]="val.value"
                     [disabled]="edit"
                     (change)="onChangeSelectForm($event,'transfer', 'typeTransfer')"
                     [checked]="formTransfer.get('typeTransfer').value.includes(val.value)"
                     class="me-2"
                     style="cursor: pointer"
                   />
                 </label>
              </div>

            </div>

              <div class="d-flex flex-column p-3" style="width: 75%; background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;">
              <p class="mb-2" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Tipo traslado</p>
               <!-- <input type="text" formControlName="meals"> -->
               <span class="d-flex flex-row flex-wrap w-100" >
                <div *ngFor="let val of vehicleTypes; let i = index" class="pr-3" style=" min-width: 20%;">
                    <label class="mb-1 pb-1 form-check-label d-flex w-100 justify-content-between align-items-center"
                    [ngStyle]="{'border-bottom': i < 5 ? '1px solid #ececec' : ''}">
                      <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                      <input
                        type="checkbox"
                        [value]="val.value"
                        [disabled]="edit"
                        (change)="onChangeSelectForm($event,'transfer', 'typeVehicle')"
                        [checked]="formTransfer.get('typeVehicle').value.includes(val.value)"
                        class="me-2"
                        style="cursor: pointer"
                      />
                    </label>

                  </div>
                </span>
                <!-- <span class="d-flex flex-row flex-wrap w-100" > -->
                  <!-- <label class="form-check-label d-flex  align-items-center" style="gap: .5em; min-width: 20%;">
                      <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                      <input
                        type="checkbox"
                        [value]="val.value"
                        [disabled]="edit"
                        (change)="onChangeSelectForm($event,'transfer', 'typeVehicle')"
                        [checked]="formTransfer.get('typeVehicle').value.includes(val.value)"
                        class="me-2"
                        style="cursor: pointer"
                      />
                    </label> -->
                <!-- </span> -->
            </div>

        </div>

          <div class="d-flex mt-3 flex-column">
          <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Comentario</p>
          <div class="d-flex flex-column">
            <div class="w-100 position-relative">
              <textarea name="comment_contact" id="comment_contact" class="form-control" style="min-height: 150px;" placeholder="Pregunta o comentario" formControlName="comment_contact" rows="5" id=""></textarea>
               <span *ngIf="formTransfer.get('comment_contact').value?.length === 500"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 500 caracteres
                </span>
            </div>
          </div>
         </div>


            <div *ngIf="!edit" class="d-flex pt-4 justify-content-end" style="height: 75px; gap: 1em;">
              <p style="font-family: 'Rubik', serif; font-size: 13px;">*Puede completar todos los formularios en una sola solicitud</p>

          <!-- <button type="button" class="btn btn-continue" (click)="close()" [disabled]="disableButton">Close</button> -->
          <button   type="button" class="btn btn-continue"  (click)="onSubmit()">Enviar</button>
        </div>
      </form>
    </div>

    <div [ngClass]="{'d-block': tab==='rent-a-car', 'd-none': tab!='rent-a-car' }">
      <form *ngIf=" tab==='rent-a-car'" [formGroup]="formRentACar">

        <div class="d-flex flex-column mt-3 mb-3 w-100">
          <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Fecha y dirección de recogida</p>
          <div class="d-flex mb-4" style="gap: 1em;">
              <div class="w-100 position-relative">
                <input type="text" id="origin" name="origin" class="form-control" [maxLength]="50"  placeholder="Lugar de recogida" (keydown)="blockInvalidKeys($event, 'name')" formControlName="origin">
                   <span *ngIf="
                            formRentACar.get('origin').hasError('required')"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
              >
                Obligatorio</span>
                 <span *ngIf="formRentACar.get('origin').hasError('minlength') &&
                            formRentACar.get('origin').touched"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Mínimo 3 caracteres
                </span>
                <span *ngIf="formRentACar.get('origin').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>
              </div>
          </div>
           <div class="d-flex mb-3" style="gap: 1em;">
              <div class="w-100 position-relative">
                <input type="text" id="destinationReturn" name="destinationReturn" [maxLength]="50" class="form-control" (keydown)="blockInvalidKeys($event, 'name')" placeholder="Retorno en otra ubicación (ingrese el lugar de retorno)" formControlName="destinationReturn">
                <span *ngIf="formRentACar.get('destinationReturn').hasError('minlength') &&
                            formRentACar.get('destinationReturn').touched"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Mínimo 3 caracteres
                </span>
                <span *ngIf="formRentACar.get('destinationReturn').value?.length === 50"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 50 caracteres
                </span>
              </div>
          </div>
        </div>

    <div class="d-flex" style="gap: 1em;">

      <div class="d-flex flex-column w-100">

        <div class="w-100 mb-4 position-relative">
          <input
          formControlName="pickupDate"
          type="text"
          class="form-control input-search-box"
          style="background-color: white;"
          id="departureDate"
          placeholder="Fecha retiro"
          autocomplete="off"
          bsDatepicker
          [minDate]="now"
          [bsConfig]="dpConfig"
          readonly
          [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': clientSetting?.clients_setting_global?.color_main_1},
                      ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': clientSetting?.clients_setting_global?.color_main_1}}"
        />
           <span *ngIf="
                            formRentACar.get('pickupDate').value === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
              >
                Obligatorio</span>
        </div>
    <div class="d-flex flex-column w-100 p-3" style="background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;">

      <p class="mb-2" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Horario traslado Retiro    <span *ngIf="
                            formRentACar.get('pickupTimeDay')?.value.length === 0"
                     class="text-danger ml-1"
                     style="font-size: 12px;font-weight: 600; "
              >
                Obligatorio</span></p>
                <div  *ngFor="let val of timeDay; let i = index">

                    <label class="mb-1 pb-1 w-100 form-check-label d-flex justify-content-between pr- align-items-center"
                         [ngStyle]="{'border-bottom': i !== (timeDay.length - 1) ? '1px solid #ececec' : ''}">
                    <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                     <input
                       type="checkbox"
                       [value]="val.value"
                       [disabled]="edit"
                       (change)="onChangeSelectForm($event,'rent-a-car', 'pickupTimeDay')"
                       [checked]="formRentACar.get('pickupTimeDay').value.includes(val.value)"
                       class="me-2"
                        style="cursor: pointer"
                     />
                   </label>
                </div>
    </div>

  </div>


 <div class="d-flex flex-column w-100">


               <div class="w-100 mb-4 position-relative">
                <input
                formControlName="dropoffDate"
                type="text"
                class="form-control input-search-box"
                style="background-color: white;"
                id="departureDate"
                placeholder="Fecha devolución"
                autocomplete="off"
                bsDatepicker
                [minDate]="now"
                [bsConfig]="dpConfig"
                readonly
                [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': clientSetting?.clients_setting_global?.color_main_1},
                            ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': clientSetting?.clients_setting_global?.color_main_1}}"
              />
                <span *ngIf="
                            formRentACar.get('dropoffDate')?.value === null"
                     class="position-absolute text-danger ml-2"
                     style="font-size: 12px;font-weight: 600;bottom: -20px; "
              >
                Obligatorio</span>
              </div>

    <div class="d-flex flex-column w-100 p-3" style="background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;">
      <p class="mb-2" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Horario traslado devolución
          <span *ngIf="
                            formRentACar.get('dropoffTimeDay')?.value.length === 0"
                     class="text-danger ml-1"
                     style="font-size: 12px;font-weight: 600; "
              >
                Obligatorio</span>
      </p>

        <div  *ngFor="let val of timeDay; let i = index">

                    <label class="mb-1 pb-1 w-100 form-check-label d-flex justify-content-between pr- align-items-center"
                         [ngStyle]="{'border-bottom': i !== (timeDay.length - 1) ? '1px solid #ececec' : ''}">
                    <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                      <input
                        type="checkbox"
                        [value]="val.value"
                        [disabled]="edit"
                        (change)="onChangeSelectForm($event,'rent-a-car', 'dropoffTimeDay')"
                        [checked]="formRentACar.get('dropoffTimeDay').value.includes(val.value)"
                        class="me-2"
                      />
                    </label>
            </div>

            </div>
          </div>
    </div>

        <div class="d-flex flex-column mt-3 mb-3 w-100">
          <!-- <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Tipo vehículo</p>
          <div class="d-flex mb-3" style="gap: 1em;">
              <div class="w-100">
                <input type="text"  class="form-control" placeholder="Clase o nombre de vehículo" formControlName="vehicleType">
              </div>



               <div class="d-flex align-items-center w-100" style="gap: 1em;">
                <label *ngFor="let val of transmissionType" class="form-check-label d-flex align-items-center" style="gap: .5em;">
                  <input
                    type="radio"
                    [value]="val.value"
                    formControlName="transmissionType"
                    class="me-2"
                  />
                  <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;"> {{val.label}}</span>
                </label>
               </div>
          </div> -->
        <div class="d-flex mb-3" style="gap: 1em;">
           <div class="d-flex flex-column p-3" style="width: 25%;  background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;">
              <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Tipo traslado</p>
             <div *ngFor="let val of transmissionType; let i = index">
               <label class="mb-1 pb-1 w-100 form-check-label d-flex justify-content-between pr- align-items-center"
                         [ngStyle]="{'border-bottom': i !== (boardType.length - 1) ? '1px solid #ececec' : ''}">
                 <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                  <input
                    type="checkbox"
                    [value]="val.value"
                    [disabled]="edit"
                    (change)="onChangeSelectForm($event,'rent-a-car', 'transmissionType')"
                    [checked]="formRentACar.get('transmissionType').value.includes(val.value)"
                    class="me-2"
                    style="cursor: pointer"
                  />
                </label>

             </div>
            </div>

        <div class="d-flex flex-column p-3" style="width: 75%;  background-color: #fcfcfc;border: 1px solid #ececec; border-radius: 6px;" >
              <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Tipo traslado</p>
                <span class="d-flex flex-row flex-wrap w-100" >
                  <div *ngFor="let val of vehicleTypesCar; let i = index" class="pr-3" style=" min-width: 20%;">
                   <label class="mb-1 pb-1 form-check-label d-flex w-100 justify-content-between align-items-center"
                    [ngStyle]="{'border-bottom': i < 5 ? '1px solid #ececec' : ''}">
                      <span style="font-family: 'Rubik', serif;font-weight: 400;font-size: 14px;">{{val.label}}</span>
                        <input
                          type="checkbox"
                          [value]="val.value"
                          [disabled]="edit"
                          (change)="onChangeSelectForm($event,'rent-a-car', 'vehicleType')"
                          [checked]="formRentACar.get('vehicleType').value.includes(val.value)"
                          class="me-2"
                          style="cursor: pointer"
                        />
                      </label>

                  </div>
                </span>
            </div>

        </div>

          <div class="d-flex flex-column mb-3" >
            <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Pasajeros</p>
            <div class="d-flex" style="gap: 1em;">
              <div class="w-100 position-relative">
              <input type="number" class="form-control" min="2" id="adults" name="adults" (keypress)="limitNumber($event, 99)" max="99" placeholder="Adultos" (keydown)="blockInvalidKeys($event, 'number')" formControlName="adults">
                 <span *ngIf="
                              formRentACar.get('adults').value === null"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                  <span  *ngIf="formRentACar.get('adults')?.hasError('min')"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Mínimo 1
                   </span>
                   <span *ngIf="formRentACar.get('adults')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
              </div>
              <div class="w-100 position-relative">
                <input type="number" min="0" class="form-control" id="childs" name="childs" (keypress)="limitNumber($event, 99)" max="99" (keydown)="blockInvalidKeys($event, 'number')" placeholder="Niños" formControlName="childs">
                <span *ngIf="
                              formRentACar.get('childs').value === null"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                  <span *ngIf="formRentACar.get('childs')?.value === 99"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 99
                </span>
              </div>
              <div class="w-100 position-relative">
                 <input type="text" class="form-control" id="age_childs" name="age_childs" placeholder="Edades de los niños. Ej: 1, 4, 7" (keydown)="blockInvalidKeys($event, 'age_childs')" formControlName="age_childs">
                <span *ngIf="
                              !formRentACar.get('age_childs').valid && formRentACar.get('childs').value > 0"
                        class="position-absolute text-danger ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px; "
                    >Obligatorio
                   </span>
                    <span *ngIf="
                              formRentACar.get('age_childs').value"
                        class="position-absolute ml-2"
                        style="font-size: 12px;font-weight: 600;bottom: -20px;color: #cbcbcb "
                    >Ej: 1, 4, 7
                   </span>
               </div>
            </div>
          </div>

        </div>

        <div class="d-flex mt-3 flex-column">
          <p class="mb-1" style="font-family: 'Rubik', serif;font-weight: 600;font-size: 18px;">Comentario</p>
          <div class="d-flex flex-column">
            <div class="w-100">
                <textarea name="comment_contact" id="comment_contact" class="form-control" placeholder="Pregunta o comentario" [maxLength]="500" style="min-height: 150px;" formControlName="comment_contact" rows="5" id=""></textarea>
                <span *ngIf="formRentACar.get('comment_contact').value?.length === 500"
                    class="position-absolute text-danger ml-2"
                    style="font-size: 12px; font-weight: 600; bottom: -20px;">
                  Máximo 500 caracteres
                </span>
            </div>
          </div>
         </div>

            <div *ngIf="!edit" class="d-flex pt-4 justify-content-end" style="height: 75px; gap: 1em;">


                  <!-- <button type="button" class="btn btn-continue" (click)="close()" [disabled]="disableButton">Close</button> -->
                  <button type="button" class="btn btn-continue"  (click)="onSubmit()">Enviar</button>
        </div>
      </form>
    </div>
</div>



<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size = "medium" color="#fa1a1a" type="line-scale">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
